import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyPaymentApi } from "../api/apiServices";

export default function VerifyPaystackPayment({
  onSuccess,
  onError
}) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const reference = searchParams.get("reference");
    if (!reference) return;

    const verify = async () => {
      try {
        const data = await verifyPaymentApi(reference);

        if (data.success && data.order) {
          onSuccess?.(data.order);

          // Clean URL to prevent re-verification on refresh
          window.history.replaceState({}, "", "/payment/success");
        } else {
          throw new Error(data.message || "Verification failed");
        }
      } catch (err) {
        console.error("Payment verification failed", err);

        onError?.(
          err.response?.data?.message ||
            err.message ||
            "Payment verification failed"
        );
      }
    };

    // slight delay to avoid double-trigger
    const timer = setTimeout(verify, 700);
    return () => clearTimeout(timer);
  }, [searchParams]);

  return null;
}
